import { Component, EventEmitter, Input, Output } from '@angular/core'
import { SigadEnvioStatus } from 'src/app/models/sigad-protocolo'

@Component({
  selector: 'inscricoes-processo-digital-acoes',
  templateUrl: './processo-digital-acoes.component.html',
  styleUrls: ['./processo-digital-acoes.component.scss'],
})
export class ProcessoDigitalAcoesComponent {
  @Input() hasFormErrors: boolean = false

  @Input() statusInscricoes!: SigadEnvioStatus
  @Input() statusDeclaracoes!: SigadEnvioStatus
  @Input() statusResultadoFase1!: SigadEnvioStatus
  @Input() statusResultadoFase2!: SigadEnvioStatus

  @Input() prazoInscricaoEncerrado: boolean = false
  @Input() temInscricoesAguardandoAnalise: boolean = false

  @Output() enviarDocsEv = new EventEmitter()
  @Output() enviarDeclaracoesEv = new EventEmitter()
  @Output() enviarClassificacaoFase1Ev = new EventEmitter()
  @Output() enviarClassificacaoFase2Ev = new EventEmitter()

  // Verifica se as inscrições estão completas
  get inscricoesCompletas(): boolean {
    return (
      this.statusInscricoes &&
      this.statusInscricoes.total > 0 &&
      this.statusInscricoes.totalCompleto === this.statusInscricoes.total
    )
  }

  // Verifica se as declarações estão completas
  get declaracoesCompletas(): boolean {
    return (
      this.statusDeclaracoes &&
      this.statusDeclaracoes.total > 0 &&
      this.statusDeclaracoes.totalCompleto === this.statusDeclaracoes.total
    )
  }

  // Verifica se a classificação fase 1 está completa
  get classificacaoFase1Completa(): boolean {
    return (
      this.statusResultadoFase1 &&
      this.statusResultadoFase1.total > 0 &&
      this.statusResultadoFase1.totalCompleto === this.statusResultadoFase1.total
    )
  }


  enviarDocs() {
    this.enviarDocsEv.emit()
  }

  enviarDeclaracoes() {
    this.enviarDeclaracoesEv.emit()
  }

  enviarClassificacaoFase1() {
    this.enviarClassificacaoFase1Ev.emit()
  }

  enviarClassificacaoFase2() {
    this.enviarClassificacaoFase2Ev.emit()
  }


  get classificacaoFase2Completa(): boolean {
    return (
      this.statusResultadoFase2 &&
      this.statusResultadoFase2.total > 0 &&
      this.statusResultadoFase2.totalCompleto === this.statusResultadoFase2.total
    )
  }

}
